<template lang="pug">
  .site-container
    .b-successful-register-page.empty-page
      ._container.empty-page-container
        ._content.empty-page-content
          Icon(name="successful")
          h1._subtitle Поздравляем!
          h2._title Вы успешно зарегистрировались в системе!
          Btn(:to="{ name: 'auth-login' }") Войти в систему
        AuthFooter(hideEmail)
</template>

<script>
import AuthFooter from '@/components/AuthFooter.vue';

export default {
  components: { AuthFooter },
};
</script>

<style lang="scss" scoped>
.successful-register-page {

  &__content {
    flex-direction: column;
    text-align: center;
    margin-bottom: 30px;
  }

  svg {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    margin-bottom: 22px;
  }
  &__subtitle {
    font-weight: 700;
    font-size: 20px;
    line-height: 20px;
    color: var(--color-green-st);
    margin-bottom: 17px;
  }
  &__title {
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 34px;
    color: var(--color-middle-gray);
  }
  &__desc {
    max-width: 509px;
    margin: 0 auto;
    text-align: left;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-middle-gray);
    &:not(:last-child) {
      margin-bottom: 44px;
    }
  }
  &__link {
    color: var(--color-accent);
  }

  @media (max-width: 500px) {
    &__container {
      padding: 20px 15px;
    }

    &__content {
      padding: 30px 20px;
    }

    &__title {
      margin-bottom: 12px;
    }

    &__desc:not(:last-child) {
      margin-bottom: 16px;
    }
  }
}
</style>
